import { timelineCards } from "@/mocks/home";

export default function Timeline() {
  const feature = timelineCards.find((c) => c.size === "feature");
  const smalls = timelineCards.filter((c) => c.size !== "feature");
  const legend = ["全部", "紧急爆料", "新瓜", "跟进", "辟谣", "碎片"];

  return (
    <section id="timeline" className="mx-auto max-w-6xl scroll-mt-24 px-4 pt-16 md:px-6 md:pt-24">
      {/* header */}
      <div className="flex flex-col gap-4 border-b border-line pb-5">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-muted">Issue · 新瓜时间线</p>
            <h3 className="font-display mt-2 text-2xl font-bold tracking-tight text-ink md:text-3xl">
              911网最新消息，一条条按时刻排开
            </h3>
          </div>
          <span className="font-display text-5xl font-black leading-none text-line md:text-6xl">214</span>
        </div>
        <div className="flex flex-wrap gap-2">
          {legend.map((l) => (
            <span
              key={l}
              className="whitespace-nowrap rounded-full px-3 py-1 text-xs text-muted ring-1 ring-line transition-colors hover:bg-paper-2 hover:text-ink"
            >
              {l}
            </span>
          ))}
        </div>
      </div>

      {/* 大小卡混排 */}
      <div className="mt-8 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-6">
        {feature && (
          <article className="relative flex flex-col rounded-lg bg-paper-2 p-6 sm:col-span-2 md:p-7 lg:col-span-3 lg:row-span-2 lg:p-8">
            <span className="pointer-events-none absolute right-5 top-4 font-display text-7xl font-black leading-none text-ink/[0.06] lg:text-8xl">
              {feature.seq}
            </span>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent px-2.5 py-1 text-white">
                <i className="ri-flashlight-line text-[12px]" /> {feature.tag}
              </span>
              <span className="tabular-nums">{feature.batch} · {feature.time}</span>
            </div>
            <h4 className="font-display mt-6 max-w-[24ch] text-2xl font-black leading-snug tracking-tight text-ink md:text-[1.7rem] lg:mt-8">
              {feature.title}
            </h4>
            <p className="mt-4 max-w-[46ch] text-[15px] leading-7 text-ink/80">{feature.lead}</p>
            <div className="mt-auto flex items-center justify-between gap-4 pt-8">
              <div className="flex flex-wrap items-center gap-3 text-xs text-muted">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-community-line text-[13px]" /> 2 个独立信源
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-list-check-2 text-[13px]" /> 0 个待补口子
                </span>
              </div>
              <a
                href="#scene"
                className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-accent transition-colors hover:text-accent-deep"
              >
                去现场 <i className="ri-arrow-right-line text-[15px]" />
              </a>
            </div>
          </article>
        )}

        {smalls.map((card) => (
          <article
            key={card.id}
            className="group flex cursor-pointer flex-col border-t border-line-strong pt-4 sm:col-span-1 lg:col-span-1"
          >
            <div className="flex items-center gap-3 text-xs text-muted">
              <span className="font-display text-sm font-bold tabular-nums text-ink">{card.seq}</span>
              <span className="tabular-nums">{card.batch}</span>
              <span className="text-line-strong">·</span>
              <span className="uppercase tracking-wider">{card.time}</span>
              <span className="ml-auto rounded-full bg-accent-soft px-2 py-0.5 text-accent-deep">
                {card.tag}
              </span>
            </div>
            <h4 className="font-display mt-3 text-lg font-bold leading-snug text-ink transition-colors group-hover:text-accent-deep lg:mt-4">
              {card.title}
            </h4>
            <p className="mt-2 text-sm leading-6 text-muted">{card.lead}</p>
          </article>
        ))}
      </div>
    </section>
  );
}